/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    il_opus_reference_id: '',
    il_trade_partner_id_client: '',
    il_team_id: '',
    il_trade_partner_id_shipper: '',
    il_trade_partner_id_consignee: '',
    bol: '',
    shipment_type: '-',
    etd: null,
    eta: null,
    feta: null,
    il_ftl_ltl_alias: [],
    rate_copy: false,
};

const truckingShipmentFormSlice = createSlice({
    name: 'truckingNewShipmentForm',
    initialState,
    reducers: {
        setFormData: (state, action) => {
            return { ...state, ...action.payload };
        },
        addAlias: (state, action) => {
            state.il_ftl_ltl_alias.push(action.payload);
        },
        deleteAlias: (state, action) => {
            const tabId = action.payload;
            return { ...state, il_ftl_ltl_alias: state.il_ftl_ltl_alias.filter((alias) => alias.id !== tabId) };
        },
        updateAlias: (state, action) => {
            const { aliasId, updatedAlias } = action.payload;
            state.il_ftl_ltl_alias = state.il_ftl_ltl_alias.map((item) =>
                item.id === aliasId ? { ...item, ...updatedAlias } : item
            );
        },

        resetFormData: (state) => {
            return initialState;
        },
    },
});

export const { setFormData, addAlias, deleteAlias, updateAlias, resetFormData } = truckingShipmentFormSlice.actions;
export default truckingShipmentFormSlice.reducer;
